import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function tipoPessoaReducer(state = initialState.tipoPessoa, action){
    switch(action.type) {
        case types.LISTAR_TIPO_PESSOA_VISIVEL:
            
            return {...state, tiposVisiveis: action.payload};;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/tipoPessoaReducer.js
 **/